import React from 'react';
import { connect } from 'react-redux';
import Counter from '../../../shared/components/Counter';
import { isNothingNamedField } from '../../Fields/constants';

class FactorsListSectionCounter extends React.Component {
  render() {
    const nothingFieldId = this.props.fields.find((field) =>
      isNothingNamedField(field?.name),
    )?.id;

    const isNothingPicked =
      this.props.alleviating?.length > 0 &&
      this.props.alleviating[0] === nothingFieldId;
    console.log('NOTHING', nothingFieldId, isNothingPicked);

    return (
      <Counter
        value={
          isNothingPicked
            ? 1
            : this.props.alleviating?.length + this.props.ineffective?.length
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let alleviating =
    state.records?.current?.record?.fields?.alleviating_factor || [];
  let ineffective =
    state.records?.current?.record?.fields?.ineffective_factor || [];

  return {
    fields: state.fields.alleviating_factor,
    alleviating,
    ineffective,
  };
};

export default connect(mapStateToProps)(FactorsListSectionCounter);
